// src/logger.ts
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';

interface ErrorEntry {
  ts: string;
  type: 'error' | 'unhandledrejection' | 'react-error';
  payload: any;
}

async function ensureLogsDir() {
  try {
    await Filesystem.mkdir({
      path: 'logs',
      directory: Directory.Documents,
      recursive: false,  // or true if you want deeper nested dirs
    });
  } catch (e: any) {
    // EEXIST is fine; anything else you might want to know
    if (e.message && !e.message.includes('exists')) {
      console.error('mkdir(logs) failed:', e);
    }
  }
}

async function writeErrorFile(entry: ErrorEntry) {
  await ensureLogsDir();        // ⇐ create the folder if needed
  const safeTs = entry.ts.replace(/[:.]/g,'-');
  const fileName = `logs/error-${safeTs}.json`;
  try {
    await Filesystem.writeFile({
      path: fileName,
      data: JSON.stringify(entry, null,2),
      directory: Directory.Documents,
      encoding: Encoding.UTF8,
    });
    console.info(`✅ Wrote error log: ${fileName}`);
  } catch (err) {
    console.error('❌ Failed to write error log –', err);
  }
}

// Global JS errors
window.onerror = (_, source, lineno, colno, err) => {
  const entry: ErrorEntry = {
    ts: new Date().toISOString(),
    type: 'error',
    payload: { message: (err as any)?.message || '', source, lineno, colno, stack: (err as any)?.stack },
  };
  writeErrorFile(entry);
};

// Unhandled Promise rejections
window.onunhandledrejection = (event) => {
  const entry: ErrorEntry = {
    ts: new Date().toISOString(),
    type: 'unhandledrejection',
    payload: { reason: event.reason },
  };
  writeErrorFile(entry);
};

export { writeErrorFile };